import React, { useContext } from 'react';
import { Dialog } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import { DocumentDialogProps } from '../interfaces';
import DocumentForm from '../../forms/documents/DocumentForm';
import { Store } from '../../../store/AppGlobalContext';
import { storeActions } from '../../../store/actions';

const useStyles = makeStyles(() => createStyles({
  paperWidth: {
    width: 376,
  },
}));

const DocumentModal: React.FC<DocumentDialogProps> = (props:DocumentDialogProps) => {
  const { dispatch } = useContext(Store);
  const {
    isOpen, title, leaseId,
  } = props;
  const formData = {
    title: '',
    url: '',
    type: '',
    leaseId,
  };

  const classes = useStyles();

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={isOpen}
      onClose={() => dispatch({ type: storeActions.HIDE_DOCUMENT_MODAL })}
      classes={{
        paper: classes.paperWidth,
      }}

    >
      <DialogTitle id="dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <DocumentForm model={formData} />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentModal;
